import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Facebook } from '../../../../images/svgs/social/facebook.svg';
import { ReactComponent as X } from '../../../../images/svgs/social/x.svg';
import { ReactComponent as Youtube } from '../../../../images/svgs/social/youtube.svg';
import { ReactComponent as Instagram } from '../../../../images/svgs/social/instagram.svg';
import { ReactComponent as Linkedin } from '../../../../images/svgs/social/linkedin.svg';
import styles from './FooterSocial.module.css';

const NETWORKS = [
  {
    href: 'https://www.facebook.com/prsebrae',
    Component: Facebook,
    labelKey: 'FACEBOOK_LINK'
  },
  { href: 'https://x.com/SEBRAE_PR', Component: X, labelKey: 'TWITTER_LINK' },
  {
    href: 'https://www.youtube.com/prsebrae',
    Component: Youtube,
    labelKey: 'YOUTUBE_LINK'
  },
  {
    href: 'https://www.instagram.com/sebraepr/',
    Component: Instagram,
    labelKey: 'INSTAGRAM_LINK'
  },
  {
    href: 'https://www.linkedin.com/company/sebrae-pr/',
    Component: Linkedin,
    labelKey: 'LINKEDIN_LINK'
  }
];

export default function FooterSocial() {
  const { t } = useTranslation('footer');
  return (
    <div className={styles.root}>
      <div className={styles.title}>{t('ACCOMPANY')}</div>
      <div className={styles.icons}>
        {NETWORKS.map(({ href, Component, labelKey }) => (
          <a
            key={href}
            href={href}
            target='_blank'
            rel='noopener noreferrer'
            aria-label={t(labelKey)}
            className={styles.icon}>
            <Component className={styles.svg} />
          </a>
        ))}
      </div>
    </div>
  );
}
